<template>
  <aside :class="'sidebar-resp ' + {is_expanded: is_expanded, expandedRes: hasRes}" class="sidebare-left">
    <div class="menu">
      <!-- <router-link
        v-show="exist"
        class="link"
        :to="{ name: 'dashboard' }"
        :class="{'router-link-exact-active is-active active': isAddAccueilDeclaration}"
      >
        <i class="material-icons icon-clipboard" />
        <span class="text">Page d'Accueil</span>
      </router-link> -->

      <router-link
        v-if="exist"
        class="link link-gen"
        :to="{name: 'dashboard'}"
        :class="{
          'router-link-exact-active is-active active': isAddAccueilDeclaration,
        }"
      >
        <i class="material-icons icon-dashboard" />
        <span class="text link-gen-g">{{ $t("sidebar.dashboard") }}</span>
      </router-link>

      <div class="link link-accordion">
        <div
          v-show="existDev || existNote || existRegiAppel"
          ref="accordionScol"
          class="accordion"
          :class="{
            'router-link-exact-active is-active active': isNoteDeclaration || isAddRegisterDeclaration || isAddHomeWorkDeclaration1,
          }"
        >
          <div>
            <i class="material-icons icon-actualite" />
            <span class="text link-gen-g">{{ $t("sidebar.scolarite") }}</span>
          </div>
          <div>
            <i class="arrow down" />
          </div>
        </div>
        <div class="contenu-accordion">
          <router-link
            v-if="existDev"
            class="ml-left"
            :to="{name: 'home_works'}"
            :class="{
              'router-link-exact-active is-active active': isAddHomeWorkDeclaration1,
            }"
          >
            <!-- <i class="material-icons icon-clipboard" /> -->
            <span class="text">{{ $t("sidebar.devoirs") }}</span>
          </router-link>
          <router-link
            v-if="existNote"
            class="ml-left"
            :to="{name: 'examSchedule'}"
            :class="{
              'router-link-exact-active is-active active': isExamSchedule,
            }"
          >
            <!-- <i class="icon-article" /> -->
            <span class="text">{{ $t("sidebar.examSchedule") }}</span>
          </router-link>

          <div ref="accordionNote" :class="{active: isActVisible}" class="accordion accordActuality">
            <div>
              <span class="text">{{ $t("sidebar.noteExam") }}</span>
            </div>
            <div>
              <i class="arrow down" />
            </div>
          </div>

          <div class="contenu-accordion meni-muni">
            <router-link class="ml-left" :to="{name: 'ListNotes'}">
              <span class="text">{{ $t("common.communicationNotes") }}</span>
            </router-link>
            <router-link v-if="schoolCategory" class="ml-left" :to="{name: 'BulletinNotes'}">
              <span class="text">{{ $t("common.bulletinNotes") }}</span>
            </router-link>
          </div>

          <router-link v-show="existRegiAppel" class="ml-left" :to="{name: 'ShowRegisterPresenc'}">
            <!-- <i class="material-icons icon-actualite" /> -->
            <span class="text">{{ $t("sidebar.register") }}</span>
          </router-link>
        </div>
      </div>
      <div v-show="exist" class="link link-accordion link-gen">
        <div
          v-show="existPay"
          ref="accordionPayment"
          class="accordion"
          :class="{
            'router-link-exact-active is-active active': isAddPaymentDeclaration || isAddServiceDeclaration || isAddServiceAffectation,
          }"
        >
          <div>
            <i class="material-icons icon-payment" />
            <span class="text link-gen-g">{{ $t("sidebar.paiements") }}</span>
          </div>
          <div>
            <i class="arrow down" />
          </div>
        </div>
        <div class="contenu-accordion">
          <router-link
            class="ml-left"
            :to="{name: 'PaymentList'}"
            :class="{
              'router-link-exact-active is-active active': isAddPaymentDeclaration,
            }"
          >
            <span class="text">{{ $t("sidebar.suivPaiements") }}</span>
          </router-link>

          <div ref="accordionParametrage" :class="{active: isActVisible}" class="accordion accordActuality">
            <div>
              <span class="text">{{ $t("sidebar.parametre") }}</span>
            </div>
            <div>
              <i class="arrow down" />
            </div>
          </div>

          <div class="contenu-accordion meni-muni">
            <router-link
              class="ml-left"
              :to="{name: 'ServiceList'}"
              :class="{
                'router-link-exact-active is-active active': isAddServiceDeclaration,
              }"
            >
              <!-- <i class="icon-service" /> -->
              <span class="text">{{ $t("sidebar.services") }}</span>
            </router-link>
            <router-link
              class="ml-left"
              :to="{name: 'ParamService'}"
              :class="{
                'router-link-exact-active is-active active': isAddServiceAffectation,
              }"
            >
              <!-- <i class="icon-categorie" /> -->
              <span class="text test-affect">{{ $t("sidebar.affectation") }}</span>
            </router-link>
          </div>
        </div>
      </div>

      <div v-show="exist" class="link link-accordion link-gen">
        <div
          ref="accordionActualites"
          class="accordion"
          :class="{
            'router-link-exact-active is-active active':
              isAddRendezDeclaration || isAddArticleDeclaration || isAddCategorieDeclaration || isAddEventsDeclaration || isAddMessageDeclaration || isAddCantineDeclaration,
          }"
        >
          <div>
            <i class="material-icons icon-actualite" />
            <span class="text link-gen-g">{{ $t("sidebar.communication") }}</span>
          </div>
          <div>
            <i class="arrow down" />
          </div>
        </div>
        <div class="contenu-accordion accord-parent">
          <router-link
            class="ml-left"
            v-show="existMess"
            to="/messages"
            :class="{
              'router-link-exact-active is-active active': isAddMessageDeclaration,
            }"
          >
            <!-- <i class="material-icons icon-message-dots-circle" /> -->
            <span class="text">{{ $t("sidebar.messages") }}</span>
            <span v-if="nbMessageNotLu > 0" class="counter">
              <span class="count">{{ nbMessageNotLu }}</span>
            </span>
          </router-link>
          <router-link v-show="existRendezVous" :to="{name: 'listeRdv'}">
            <span class="text">{{ $t("sidebar.rdv") }}</span>
          </router-link>
          <router-link
            class="ml-left"
            v-show="existEven"
            :to="{name: 'eventsList'}"
            :class="{
              'router-link-exact-active is-active active': isAddEventsDeclaration,
            }"
          >
            <!-- <i class="material-icons icon-event" /> -->
            <span class="text">{{ $t("sidebar.events") }}</span>
          </router-link>

          <div ref="accordionActu" :class="{active: isActVisible}" class="accordion accordActuality">
            <div>
              <span class="text">{{ $t("sidebar.actuality") }}</span>
            </div>
            <div>
              <i class="arrow down" />
            </div>
          </div>

          <div class="contenu-accordion meni-muni">
            <router-link
              class="ml-left"
              :to="{name: 'articleList'}"
              :class="{
                'router-link-exact-active is-active active': isAddArticleDeclaration,
              }"
            >
              <!-- <i class="icon-article" /> -->
              <span class="text">{{ $t("sidebar.listArticle") }}</span>
            </router-link>
            <router-link
              class="ml-left"
              :to="{name: 'categorieList'}"
              :class="{
                'router-link-exact-active is-active active': isAddCategorieDeclaration,
              }"
            >
              <!-- <i class="icon-categorie" /> -->
              <span class="text">{{ $t("sidebar.categories") }}</span>
            </router-link>
          </div>

          <router-link v-if="existCantine" class="ml-left" :to="{name: 'cantineList'}">
            <!-- <i class="material-icons icon-cantine" /> -->
            <span class="text">{{ $t("sidebar.cantine") }}</span>
          </router-link>
        </div>
      </div>

      <div v-show="exist" class="link link-accordion link-gen">
        <div
          ref="accordion"
          class="accordion"
          :class="{
            'router-link-exact-active is-active active':
              isAddCourseDeclaration || isAddClassDeclaration || isAddTeacherDeclaration || isAddStudentDeclaration || isAddParentsDeclaration,
          }"
        >
          <div>
            <i class="material-icons icon-settings" />
            <span class="text link-gen-g">{{ $t("sidebar.gestEcole") }}</span>
          </div>
          <div>
            <i class="arrow down" />
          </div>
        </div>

        <div class="contenu-accordion">
          <router-link
            :to="{name: 'student_list'}"
            class="ml-left"
            :class="{
              'router-link-exact-active is-active active': isAddStudentDeclaration,
            }"
          >
            <!-- <i class="material-icons icon-graduation-hat" /> -->
            <span class="text">{{ $t("sidebar.students") }}</span>
          </router-link>
          <router-link :to="{name: 'parent_list'}">
            <!-- <i class="icon-children material-icons"></i> -->
            <span class="text">{{ $t("sidebar.parents") }}</span>
          </router-link>
          <router-link
            :to="{name: 'teacher_list'}"
            class="ml-left"
            :class="{
              'router-link-exact-active is-active active': isAddTeacherDeclaration,
            }"
          >
            <!-- <i class="material-icons icon-teacher" /> -->
            <span class="text">{{ $t("sidebar.teachers") }}</span>
          </router-link>
          <router-link
            v-show="exist"
            class="ml-left"
            :to="{name: 'ClasseList'}"
            :class="{
              'router-link-exact-active is-active active': isAddClassDeclaration,
            }"
          >
            <!-- <i class="material-icons icon-stand" /> -->
            <span class="text">{{ $t("sidebar.classes") }}</span>
          </router-link>
          <router-link
            :to="{name: 'MatiereList'}"
            class="ml-left"
            :class="{
              'router-link-exact-active is-active active': isAddCourseDeclaration,
            }"
          >
            <!-- <i class="icon-book-open" /> -->
            <span class="text">{{ $t("sidebar.courses") }}</span>
          </router-link>
        </div>
      </div>
      <router-link v-show="!exist" class="link link-admin" :to="{name: 'school_list'}">
        <i class="material-icons icon-settings" />
        <span class="text text-admin">{{ $t("sidebar.schools") }}</span>
      </router-link>
      <router-link v-show="!exist" class="link link-admin" :to="{name: 'periodexam_list'}">
        <i class="material-icons icon-settings" />
        <span class="text text-admin">{{ $t("sidebar.periodExam") }}</span>
      </router-link>
    </div>
  </aside>
</template>

<script>
import MessageService from "../../services/message.service";
import {mapGetters} from "vuex";
export default {
  name: "MenuSidebar",
  props: {
    is_expanded: {
      type: Boolean,
      default: true,
    },
    hasRes: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      token: null,
      // userRoles:[],
      nbMessagesSent: 0,
      nbrReceivedMessages: 0,
      params: {
        q: "",
        limit: 20,
        page: 1,
        sort: "created_at",
        order: false,
        notice_status: "received",
      },
      isActVisible: false,
      messages: [],
      exist: false,
      existDev: false,
      existNote: false,
      existMess: false,
      existPay: false,
      existAct: false,
      existEven: false,
      existRegiAppel: false,
      existRendezVous: false,
      existCantine: false,
      storedUser: {},
      schoolCategory: false,
    };
  },
  computed: {
    isAddAccueilDeclaration() {
      return this.$route.matched.some((route) => route.name.indexOf("dashboard") > 0);
    },
    isAddHomeWorkDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("devoirs") > 0);
    },
    isAddHomeWorkDeclaration1() {
      return this.$route.matched.some((route) => route.path.indexOf("devoirs") > 0);
    },
    isAddMessageDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("messages") > 0);
    },
    isAddRendezDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("rdv") > 0);
    },
    isAddTeacherDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("teachers") > 0);
    },
    isAddRegisterDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("register") > 0);
    },
    isAddStudentDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("eleves") > 0);
    },
    isAddParentsDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("parents") > 0);
    },
    isAddClassDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("classes") > 0);
    },
    isAddCourseDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("courses") > 0);
    },
    isAddParentDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("parents") > 0);
    },
    isAddServiceAffectation() {
      return this.$route.matched.some((route) => route.path.indexOf("parametrageServices") > 0);
    },
    isAddServiceDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("services") > 0);
    },
    isAddPaymentDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("payments") > 0);
    },
    isAddEventsDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("evenements") > 0);
    },
    isAddCantineDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("cantines") > 0);
    },
    isAddArticleDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("articles") > 0);
    },
    isNoteDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("notes") > 0);
    },
    isBulletinNoteDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("bulletin-notes") > 0);
    },
    isExamSchedule() {
      return this.$route.matched.some((route) => route.path.indexOf("exam/schedule") > 0);
    },
    isAddCategorieDeclaration() {
      return this.$route.matched.some((route) => route.path.indexOf("categories") > 0);
    },

    userRoles() {
      return this.$store.state?.auth?.user?.role;
    },
    userModules() {
      return this.$store.state?.auth?.user?.modules;
    },
    ...mapGetters(["nbMessageNotLu"]),
  },
  created() {
    ///  this.userroles= this.$store.state.auth.user.role;
    this.token = localStorage.getItem("token");
  },
  mounted() {
    this.schoolCategory = JSON.parse(localStorage.getItem("school_category"));
    this.eventAccordion(this.$refs.accordion);
    this.eventAccordion(this.$refs.accordionActualites);
    this.eventAccordion1(this.$refs.accordionActu);
    this.eventAccordionParametrage(this.$refs.accordionNote);
    this.eventAccordionParametrage(this.$refs.accordionParametrage);
    this.eventAccordion(this.$refs.accordionScol);
    this.eventAccordion(this.$refs.accordionPayment);
    this.roleUser();
    this.moduleUser();
    this.countMessages();
  },
  methods: {
    eventAccordion1(variable) {
      variable.addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;

        if (panel.classList.contains("menuAct")) {
          panel.classList.remove("menuAct");
        } else {
          panel.classList.add("menuAct");
        }
      });
    },
    eventAccordionParametrage(variable) {
      variable.addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;

        if (panel.classList.contains("menuAct")) {
          panel.classList.remove("menuAct");
        } else {
          panel.classList.add("menuAct");
        }
      });
    },
    eventAccordion(variable) {
      variable.addEventListener("click", function () {
        this.classList.toggle("active");
        var panel = this.nextElementSibling;

        var elements = document.querySelectorAll(".accordion");
        for (var i = 0; i < elements.length; i++) {
          if (elements[i].nextElementSibling != panel) {
            elements[i].classList.remove("active");
            elements[i].nextElementSibling.style.height = null;
            if (elements[i].nextElementSibling.classList.contains("menuAct")) {
              elements[i].nextElementSibling.classList.remove("menuAct");
            }
          }
        }
        if (panel.style.height) {
          panel.style.height = null;
        } else {
          panel.style.height = "auto";
        }
      });
    },
    roleUser() {
      this.userRoles?.map((res) => {
        if (res.name == "admin_school") {
          return (this.exist = true);
        }
      });
    },
    moduleUser() {
      //this.userModules.find((element) =>{ return element.name === name})
      if (this.userModules) {
        this.existDev = this.checkModule(this.$t("modules.homeWork"));
        this.existNote = this.checkModule(this.$t("modules.note"));
        this.existRegiAppel = this.checkModule(this.$t("modules.registerAppel"));
        this.existPay = this.checkModule(this.$t("modules.payment"));
        this.existMess = this.checkModule(this.$t("modules.notices"));
        this.existRendezVous = this.checkModule(this.$t("modules.rendezVous"));
        this.existEven = this.checkModule(this.$t("modules.events"));
        this.existAct = this.checkModule(this.$t("modules.news"));
        this.existCantine = this.checkModule(this.$t("modules.cantine"));
      }
    },
    checkModule(name) {
      return this.userModules.some((element) => element.name === name);
    },
    countMessages() {
      if (this.token) {
        MessageService.nbCount().then((response) => {
          this.nbrReceivedMessages = response.data.nbr_received_messages;
          this.$store.dispatch("setNbMessage", this.nbrReceivedMessages);
        });
      }
    },
    handleScroll(evt, el) {
      if (window.scrollY > 50) {
        el.setAttribute("style", "opacity: 1; transform: translate3d(0, -10px, 0)");
      }
      return window.scrollY > 100;
    },
  },
};
</script>
<style>
.counter {
  display: inline-block;
  width: 25px;
  height: 25px;
  background-color: #34b9bb;
  border-radius: 50%;
  text-align: center;
  margin-left: 20px;
}

.count {
  color: white;
  font-size: 13px;
  line-height: 20px;
  font-weight: 500;
}
.link-gen-g {
  color: #1a1d24 !important;
  font-weight: 700 !important;
}
.menuAct {
  height: auto !important;
}
.link-accordion .accordion.accordActuality {
  padding-left: 32px !important;
  padding-top: 6px !important;
  padding-bottom: 6px !important;
}
.contenu-accordion.menuAct .ml-left {
  padding-left: 50px !important;
}
.count {
  color: #fff !important;
}
</style>
